// FIGMA Colors
// Dark & Light Mode
const BLUE = '#4E8DED'; // BEFORE '#3e8bff'
const RED = '#E6696B';
const ORANGE = '#EC9E57';
const GREEN_DARK = '#3DAE33';
const GREEN_LIGHT = '#5ADD4F';

const LIGHT_BORDER = '#F5F5F5';
const DARK_BORDER = '#394047';

// Dark
const DARK_NAV_TOP = '#171A1E';
const DARK_NAV_SIDE = '#14171A';

const DARK_NAVIGATION = '#111417';
const DARK_BACKGROUND = '#191F24';
const DARK_DRAWERS = '#20252A';
const DARK_CARDS = '#292E33';
const DARK_FIELDS_ON_CARD = '#394047';
const DARK_FIELDS_FLOATING = '#292E33';
const DARK_BUTTON_SECONDARY = '#4B5F72';
const DARK_ICONS_DISABLED = '#777F8A';
const DARK_TEXT_FADED = '#ADB8C9';
const DARK_TEXT = '#FFFFFF';

// Light
const LIGHT_NAV_TOP = '#FBFBFB';
const LIGHT_NAV_SIDE = '#344767';
const LIGHT_NAV_SIDE_HOVER = '#2a3953';

const LIGHT_NAVIGATION = '#E9E9E9';
const LIGHT_BACKGROUND = '#E9E9E9';
const LIGHT_DRAWERS = '#F7F7F7';
const LIGHT_CARDS = '#FFFFFF';
const LIGHT_FIELDS_ON_CARD = '#F7F7F7';
const LIGHT_FIELDS_FLOATING = '#FFFFFF';
const LIGHT_BUTTON_SECONDARY = '#B2B9C4';
const LIGHT_ICONS_DISABLED = '#9BA4B1';
const LIGHT_TEXT_FADED = '#6A7381';
const LIGHT_TEXT = '#353B43';

// Utility to convert hex + alpha to 8-digit hex
function withAlpha(hex: string, alphaHex: string): string {
  return `${hex}${alphaHex}`;
}

export const COLORS = {
  // New constants used in code base

  //Autofill color
  TRANSPARENT_AUTOFILL: 'background-color 99999s ease-out', // 11.5 days before chrome applies autofill color

  // Asterisk
  ERROR_ASTERISK: RED,

  // AVATAR
  PRIMARY_AVATAR_BACKGROUND: BLUE,
  WARNING_AVATAR_BACKGROUND: ORANGE,
  ERROR_AVATAR_BACKGROUND: RED,
  GREEN_DARK_AVATAR_BACKGROUND: GREEN_DARK,
  GREEN_LIGHT_AVATAR_BACKGROUND: GREEN_LIGHT,
  DARK_AVATAR_BACKGROUND: DARK_BUTTON_SECONDARY,

  // MAIN BACKGROUND
  PRIMARY_BACKGROUND: BLUE,
  DARK_BACKGROUND: DARK_BACKGROUND,
  LIGHT_BACKGROUND: LIGHT_BACKGROUND,
  WHITE_BACKGROUND: LIGHT_CARDS,
  ERROR_BACKGROUND: RED,
  WARNING_BACKGROUND: ORANGE,

  // BADGE COLOR DARK
  DARK_BADGE: DARK_NAVIGATION,

  // BADGE COLOR LIGHT
  LIGHT_BADGE: LIGHT_CARDS,

  // BADGE BACKGROUND DARK
  ERROR_BADGE_BACKGROUND: RED,
  DARK_BADGE_BACKGROUND: DARK_FIELDS_ON_CARD,
  LIGHTER_DARK_BADGE_BACKGROUND: DARK_TEXT_FADED,

  // BADGE BACKGROUND LIGHT
  LIGHT_BADGE_BACKGROUND: LIGHT_CARDS,

  // BAR
  PASS_BAR_PROGRESS: GREEN_LIGHT,
  ERROR_BAR_PROGRESS: RED,
  WARNING_BAR_PROGRESS: ORANGE,
  PRIMARY_BAR_PROGRESS: BLUE,

  DARK_BAR_TRACK: DARK_FIELDS_ON_CARD,
  LIGHT_BAR_TRACK: LIGHT_FIELDS_ON_CARD,

  // BULLET
  WARNING_BULLET: ORANGE,

  // BUTTON BACKGROUND
  PRIMARY_BUTTON_BACKGROUND: BLUE,
  PASS_BUTTON_BACKGROUND: GREEN_DARK,
  WARNING_BUTTON_BACKGROUND: ORANGE,
  ERROR_BUTTON_BACKGROUND: RED,

  DARK_BUTTON_HOVER: DARK_ICONS_DISABLED,
  PRIMARY_BUTTON_BACKGROUND_TRANSPARENT: withAlpha(BLUE, 'CC'),

  // BUTTON BACKGROUND DARK
  DARK_BUTTON_BACKGROUND: DARK_BUTTON_SECONDARY,
  DARK_SECONDARY_BUTTONBACKGROUND: DARK_FIELDS_ON_CARD,
  DARK_FIELDS_FLOATING_BUTTON_BACKGROUND: DARK_FIELDS_FLOATING,

  // BUTTON BACKGROUND LIGHT
  LIGHTER_BUTTON_BACKGROUND: LIGHT_FIELDS_ON_CARD,
  LIGHT_FIELDS_FLOATING_BUTTON_BACKGROUND: LIGHT_FIELDS_FLOATING,
  LIGHT_BUTTON_BACKGROUND: DARK_TEXT,
  OFFWHITE_BUTTON_BACKGROUND: LIGHT_BUTTON_SECONDARY,

  // BUTTON BORDERS DARK
  PRIMARY_BUTTON_BORDER: BLUE,
  DARK_BUTTON_BORDER: DARK_CARDS,
  PASS_BUTTON_BORDER: GREEN_LIGHT,
  WARNING_BUTTON_BORDER: ORANGE,
  ERROR_BUTTON_BORDER: RED,

  DARK_SECONDARY_BUTTON_BORDER: DARK_FIELDS_ON_CARD,

  // BUTTON BORDERS LIGHT
  LIGHT_BUTTON_BORDER: DARK_TEXT_FADED,
  LIGHT_BACKGROUND_BUTTON_BORDER: LIGHT_BACKGROUND,

  // BORDER
  LIGHT_BORDER: LIGHT_BORDER,
  DARK_BORDER: DARK_BORDER,

  // CALENDAR
  PRIMARY_CALENDAR_SESSION: BLUE,
  DARK_GREEN_CALENDAR_CALLBACK: GREEN_DARK,
  DARK_FIELDS_FLOATING_CALENDAR_HEADER: DARK_FIELDS_FLOATING,
  DARK_FIELDS_FLOATING_CALENDAR_BODY: DARK_FIELDS_FLOATING,

  // CARD ITEM BACKGROUND
  DARK_CARDITEM_BACKGROUND: DARK_NAVIGATION,
  LIGHT_CARDITEM_BACKGROUND: DARK_TEXT,

  // CARD ITEM BORDER
  DARK_CARDITEM_BORDER: DARK_CARDS,
  LIGHT_CARDITEM_BORDER: DARK_TEXT,

  // CHECKBOX
  PRIMARY_CHECKBOX: BLUE,
  DARK_CHECKBOX_BORDER: DARK_BUTTON_SECONDARY,

  // CHIP
  DARK_CHIP_BACKGROUND: DARK_NAVIGATION,
  LIGHT_CHIP_BACKGROUND: LIGHT_BUTTON_SECONDARY,

  // CHIP
  ERROR_CHIP_ICON: RED,

  // CIRCUAL PROGRESS BAR
  PASS_CIRCULAR_PROGRESS_BAR: GREEN_DARK,
  WARNING_CIRCULAR_PROGRESS_BAR: ORANGE,
  ERROR_CIRCULAR_PROGRESS_BAR: RED,

  // CIRCUAL PROGRESS BAR BACKGROUND
  DARK_CIRCULAR_PROGRESS_BAR_BACKGROUND: DARK_BUTTON_SECONDARY,
  GRAY_CIRCULAR_PROGRESS_BACKGROUND: LIGHT_ICONS_DISABLED,

  // CONTAINER
  PRIMARY_CONTAINER: BLUE,
  WARNING_CONTAINER: ORANGE,
  ERROR_CONTAINER: RED,
  DARKER_CONTAINER: DARK_NAVIGATION,
  DARK_CARDS_CONTAINER: DARK_CARDS,
  DARK_CONTAINER_FIELDS_ON_CARD: DARK_FIELDS_ON_CARD,
  DARK_CONTAINER_FIELDS_FLOATING: DARK_FIELDS_FLOATING,

  LIGHT_CONTAINER_FIELDS_FLOATING: LIGHT_FIELDS_FLOATING,
  LIGHT_CONTAINER: LIGHT_CARDS,
  LIGHT_CONTAINER_FIELDS_ON_CARD: LIGHT_FIELDS_ON_CARD,
  OFFWHITE_CONTAINER: LIGHT_BUTTON_SECONDARY,

  OFFWHITE_CONTAINER_TRANSPARENT: withAlpha(LIGHT_BACKGROUND, '99'),
  LIGHT_CONTAINER_TRANSPARENT: withAlpha(LIGHT_CARDS, '99'),

  DARK_CONTAINER_TRANSPARENT: withAlpha(DARK_CARDS, '99'),
  DARKER_CONTAINER_TRANSPARENT: withAlpha(DARK_NAVIGATION, '99'),

  // CONTAINER BORDER
  PRIMARY_CONTAINER_BORDER: BLUE,
  WARNING_CONTAINER_BORDER: ORANGE,
  ERROR_CONTAINER_BORDER: RED,
  DARK_GREEN_CONTAINER_BORDER: GREEN_DARK,

  DARK_CONTAINER_BORDER: DARK_CARDS,
  LIGHT_CONTAINER_BORDER: DARK_TEXT_FADED,
  LIGHT_TEXT_FADED_BORDER: LIGHT_TEXT_FADED,

  // CONTAINER LINE
  PRIMARY_CONTAINER_LINE: BLUE,
  DARK_CONTAINER_LINE: DARK_CARDS,
  LIGHT_CONTAINER_LINE: DARK_TEXT_FADED,

  // COMPOSITE CARD
  LIGHT_COMPOSITE: LIGHT_CARDS,

  // CLOCK COLOR
  LATE_SHORT_COLOR: ORANGE, // BEFORE '#d7a300'
  LATE_LONG_COLOR: RED, // BEFORE '#e53737'
  ON_TIME_COLOR: GREEN_LIGHT, // BEFORE '#80ca41'
  PRIMARY_TIME: BLUE,

  // DIALOG BACKGROUND
  PRIMARY_DIALOG_BACKGROUND: BLUE,

  DARKER_DIALOG_BACKGROUND: DARK_NAVIGATION,
  DARK_DIALOG_FIELDS_FLOATING: DARK_FIELDS_FLOATING,
  LIGHT_DIALOG_FIELDS_FLOATING: LIGHT_CARDS,

  // DIALOG CONTENT BACKGROUND
  LIGHT_DIALOG_CONTENT_BACKGROUND: LIGHT_CARDS,
  DARKER_DIALOG_CONTENT_BACKGROUND: DARK_FIELDS_FLOATING,

  // DIALOG BORDER
  PRIMARY_DIALOG_BORDER: BLUE,
  ERROR_DIALOG_BORDER: RED,
  WARNING_DIALOG_BORDER: ORANGE,

  // DIALOG BORDER IMAGE SOURCE
  PRIMARY_DIALOG_BORDER_IMAGE_SOURCE: BLUE,
  LIGHT_DIALOG_BORDER_IMAGE_SOURCE: LIGHT_ICONS_DISABLED,
  DARK_DIALOG_BORDER_IMAGE_SOURCE: DARK_CARDS,
  DARKER_DIALOG_BORDER_IMAGE_SOURCE: DARK_NAVIGATION,

  // DIALOG BACKGROUND IMAGE
  PRIMARY_DIALOG_BACKGROUND_IMAGE: BLUE,
  LIGHT_DIALOG_BACKGROUND_IMAGE: LIGHT_CARDS,
  OFFWHITE_DIALOG_BACKGROUND_IMAGE: LIGHT_BACKGROUND,
  DARKER_DIALOG_BACKGROUND_IMAGE: DARK_NAVIGATION,

  // DRAWERS
  DARK_DRAWER: DARK_DRAWERS,

  // ICON
  PRIMARY_ICON: BLUE,
  ERROR_ICON: RED,
  WARNING_ICON: ORANGE,
  DARK_GREEN_ICON: GREEN_DARK,
  LIGHT_GREEN_ICON: GREEN_LIGHT,
  PLAIN_ICON: DARK_TEXT,
  DARK_ICON: DARK_CARDS,
  DARKER_ICON: DARK_NAVIGATION,
  DISABLED_ICON: DARK_ICONS_DISABLED,

  // ICON BACKGROUND
  DARK_ICON_BACKGROUND: DARK_NAVIGATION,
  LIGHT_ICON_BACKGROUND: DARK_TEXT,
  PRIMARY_ICON_BACKGROUND: BLUE,

  // ICON HOVER
  DARK_ICON_HOVER: DARK_NAVIGATION,
  LIGHT_ICON_HOVER: DARK_TEXT,

  // INDICATORS
  PASS_INDICATOR: GREEN_LIGHT,
  ERROR_INDICATOR: RED,

  // HEADING
  DARK_HEADER_LINE: DARK_CARDS,
  DARK_FIELDS_ON_CARD_HEADER_LINE: DARK_FIELDS_ON_CARD,
  LIGHT_HEADER_LINE: DARK_TEXT_FADED,
  PRIMARY_HEADER_LINE: BLUE,

  // HEADING BACKGROUND
  PRIMARY_HEADER_BACKGROUND: BLUE,
  DARK_HEADER_BACKGROUND: DARK_NAVIGATION,
  LIGHT_HEADER_BACKGROUND: LIGHT_CARDS,

  // HEADING BORDER
  PRIMARY_HEADER_BORDER: BLUE,

  // LINKS
  PRIMARY_LINK: BLUE,

  // LOCATION CONTAINER
  ERROR_LOCATIONCONTAINER: RED,

  DARK_LOCATION_CONTAINER_BORDER: DARK_FIELDS_ON_CARD,
  LIGHT_LOCATION_CONTAINER_BORDER: LIGHT_BACKGROUND,

  // LOADING SPINNER ICON
  PRIMARY_LOADING: BLUE,

  // TOP NAVIGATION / MAIN HEADER
  DARK_TOP_NAV: DARK_NAV_TOP,
  LIGHT_TOP_NAV: LIGHT_NAV_TOP,
  DARK_TOP_NAV_ITEM_HOVER: DARK_NAVIGATION,
  LIGHT_TOP_NAV_ITEM_HOVER: LIGHT_NAVIGATION,

  // SIDE NAVIGATION
  DARK_SIDE_NAV: DARK_NAV_SIDE,
  PRIMARY_SIDE_NAV_ITEM_BORDER: BLUE,
  LIGHT_SIDE_NAV: LIGHT_NAV_SIDE,

  DARK_SIDE_NAV_ITEM_HOVER: DARK_NAVIGATION,
  LIGHT_SIDE_NAV_ITEM_HOVER: LIGHT_NAV_SIDE_HOVER,

  // MENU ITEM/DROPDOWN
  PRIMARY_MENUITEM_BACKGROUND: BLUE,
  LIGHT_MENUITEM_BACKGROUND: LIGHT_FIELDS_FLOATING,
  DARK_FIELDS_ON_CARD_MENU: DARK_FIELDS_ON_CARD,
  DARK_CARDS_BACKGROUND: DARK_CARDS,
  LIGHT_FIELDS_ON_CARD_MENU: LIGHT_FIELDS_ON_CARD,

  // MODAL
  DARK_MODAL_BACKGROUND: DARK_FIELDS_FLOATING,
  LIGHT_MODAL_BACKGROUND: LIGHT_FIELDS_FLOATING,

  // MODAL BORDER
  PRIMARY_MODAL_BORDER: BLUE,

  // PAPER
  PRIMARY_PAPER: BLUE,
  LIGHT_PAPER: LIGHT_FIELDS_ON_CARD,

  // PROGRESS OVERLAY
  DARK_PROGRESS_OVERLAY_BACKGROUND: DARK_NAVIGATION,
  LIGHT_PROGRESS_OVERLAY_BACKGROUND: DARK_TEXT_FADED,

  DARKER_PROGRESS_OVERLAY_BACKGROUND_TRANSPARENT: withAlpha(DARK_NAVIGATION, '99'),
  OFFWHITE_PROGRESS_OVERLAY_BACKGROUND_TRANSPARENT: withAlpha(LIGHT_ICONS_DISABLED, '99'),

  // SCROLL BAR
  DARK_SCROLLBAR_BACKGROUND: DARK_NAVIGATION,
  GRAY_SCROLLBAR_BACKROUND: DARK_BUTTON_SECONDARY,

  // SELECTION
  DEFAULT_FLOATING_SELECTION_DARK: DARK_FIELDS_FLOATING,
  DEFAULT_FLOATING_SELECTED_DARK: DARK_FIELDS_ON_CARD,

  // SLIDER RAIL
  PRIMARY_SLIDER_RAIL: BLUE,
  PRIMARY_SLIDER_RAIL_BACKGROUND: DARK_FIELDS_ON_CARD,

  // SLIDER THUMB
  PRIMARY_SLIDER_THUMB: BLUE,
  LIGHT_SLIDER_THUMB: LIGHT_FIELDS_FLOATING,

  // SLIDER THUMB BORDER
  PRIMARY_SLIDER_THUMB_BORDER: BLUE,

  // SLIDER TRACK
  PRIMARY_SLIDER_TRACK: BLUE,
  ON_SWITCH_TRACK: BLUE,
  DEFAULT_SWITCH_TRACK: DARK_BUTTON_SECONDARY,

  // SWITCH THUMB
  ON_SWITCH_THUMB: GREEN_LIGHT,
  DEFAULT_SWITCH_THUMB: DARK_BUTTON_SECONDARY,
  LIGHT_DEFAULT_SWITCH_THUMB: DARK_TEXT_FADED,

  // TAB
  PRIMARY_TAB_BACKGROUND: BLUE,
  DARK_TAB_BACKGROUND: DARK_BUTTON_SECONDARY,
  DARK_SECONDARY_TAB_BACKGROUND: DARK_DRAWERS,
  LIGHTER_TAB_BACKGROUND: DARK_FIELDS_ON_CARD,
  PRIMARY_TAB_BACKGROUND_TRANSPARENT: withAlpha(BLUE, 'CC'),

  // TAB BACKGROUND LIGHT
  LIGHT_TAB_BACKGROUND: DARK_TEXT,
  OFFWHITE_TAB_BACKGROUND: LIGHT_BUTTON_SECONDARY,

  // TAB BORDERS DARK
  PRIMARY_TAB_BORDER: BLUE,
  DARK_TAB_BORDER: DARK_CARDS,
  PASS_TAB_BORDER: GREEN_LIGHT,
  WARNING_TAB_BORDER: ORANGE,
  ERROR_TAB_BORDER: RED,

  // TAB BORDERS LIGHT
  LIGHT_TAB_BORDER: DARK_TEXT_FADED,

  // TEXTS/LABELS
  PRIMARY_TEXT: BLUE,
  WARNING_TEXT: ORANGE,
  ERROR_TEXT: RED,
  PLAIN_TEXT: DARK_TEXT,
  DARK_GREEN_TEXT: GREEN_DARK,
  PASS_TEXT: GREEN_LIGHT,
  LIGHT_TEXT: LIGHT_TEXT_FADED,
  DARK_TEXT: LIGHT_TEXT,

  // TEXT BACKGROUND
  WARNNG_TEXT_BACKGROUND: ORANGE,

  // TEXT FIELD/BOX BACKGROUND
  WARNING_TEXTBOX_BACKGROUND: ORANGE,
  DARK_FIELDS_ON_CARD_TEXTBOX_BACKGROUND: DARK_FIELDS_ON_CARD,
  DARK_FIELDS_FLOATING_TEXTBOX_BACKGROUND: DARK_FIELDS_FLOATING,
  DARK_TEXTBOX_BACKGROUND: DARK_CARDS,

  LIGHT_FIELDS_FLOATING_TEXTBOX_BACKGROUND: LIGHT_FIELDS_FLOATING,
  LIGHT_TEXTBOX_BACKGROUND: DARK_TEXT,

  // TEXT FIELD/BOX BORDERS
  PRIMARY_TEXTBOX_BORDER_FOCUS: BLUE,
  WARNING_TEXTBOX_BORDER: ORANGE,
  ERROR_TEXTBOX_BORDER: RED,

  DARK_FIELDS_ON_CARD_TEXTBOX_BORDER: DARK_FIELDS_ON_CARD,
  DARK_TEXTBOX_BORDER: DARK_CARDS,
  DARKER_TEXTBOX_BORDER: DARK_NAVIGATION,
  LIGHT_TEXTBOX_BORDER: LIGHT_BACKGROUND,

  // TEXT FIELD/BOX INPUT
  PLAIN_TEXTBOX_INPUT: DARK_TEXT,

  // TOAST
  DARK_TOAST_BACKGROUND: DARK_CARDS,
  DARK_TOAST_TEXT: DARK_TEXT,
  LIGHT_TOAST_BACKGROUND: LIGHT_FIELDS_ON_CARD,
  LIGHT_TOAST_TEXT: LIGHT_FIELDS_ON_CARD,
  PRIMARY_TOAST_BORDER: BLUE,

  // TOOLBAR
  DARKER_TOOLBAR_TRANSPARENT: withAlpha(DARK_NAVIGATION, '80'),

  //TOOLTIP BACKGROUND
  LIGHT_TOOLTIP_BACKGROUND: LIGHT_DRAWERS,
  DARK_TOOLTIP_BACKGROUND: DARK_DRAWERS,

  // TOOLTIP BORDER
  PRIMARY_TOOLTIP_BORDER: BLUE,
  DARK_TOOLTIP_BORDER: DARK_CARDS,
  OFFWHITE_TOOLTIP_BORDER: LIGHT_BACKGROUND,

  // USERNAME
  LIGHT_USERNAME: DARK_TEXT_FADED,

  // DARK THEME TYPE
  DEFAULT_DARK_BACKGROUND: DARK_BACKGROUND,
  PRIMARY_DARK: BLUE,
  SECONDARY_DARK: DARK_NAVIGATION,
  PRIMARY_ACTION_DARK: BLUE,

  CUSTOMGREY_DARK_LIGHT: DARK_TEXT_FADED,
  CUSTOMGREY_DARK_MAIN: DARK_ICONS_DISABLED,
  CUSTOMGREY_DARK_DARK: DARK_TEXT_FADED,
  CUSTOMGREY_DARK_CONTRASTTEXT: DARK_TEXT,

  CUSTOMBLACK_DARK_DARK: DARK_BACKGROUND,
  CUSTOMBLACK_DARK_MAIN: DARK_NAVIGATION,
  CUSTOMBLACK_DARK_LIGHT: DARK_DRAWERS,
  CUSTOMBLACK_DARK_CONTRASTTEXT: DARK_TEXT,

  // LIGHT THEME TYPE
  DEFAULT_LIGHT_BACKGROUND: DARK_BACKGROUND,
  PRIMARY_LIGHT: BLUE,
  SECONDARY_LIGHT: BLUE,
  PRIMARY_ACTION_LIGHT: LIGHT_TEXT,

  CUSTOMGREY_LIGHT_LIGHT: LIGHT_CARDS,
  CUSTOMGREY_LIGHT_MAIN: LIGHT_CARDS,
  CUSTOMGREY_LIGHT_DARK: LIGHT_CARDS,
  CUSTOMGREY_LIGHT_CONTRASTTEXT: LIGHT_TEXT,

  CUSTOMBLACK_LIGHT_DARK: LIGHT_CARDS,
  CUSTOMBLACK_LIGHT_MAIN: LIGHT_CARDS,
  CUSTOMBLACK_LIGHT_LIGHT: LIGHT_CARDS,
  CUSTOMBLACK_LIGHT_CONTRASTTEXT: LIGHT_TEXT,

  MAINMENU_BACKGROUND_COLOR_LIGHT: withAlpha(DARK_NAVIGATION, '14'),

  BLACK: '#000',
  WHITE: '#fff',

  // Old constant used in code base TO BE DELETED
  PRIMARY: BLUE,
  ERROR: '#D33535',

  MAIN_GRAY: '#6e767F',
  DARK_GRAY: '#212933',
};
